import moment from 'moment-timezone'
import get from 'lodash/get'

// eslint-disable-next-line import/prefer-default-export
export const parseAvailablePeriods = ({ startDate, endDate, startTime, endTime }) => {
  const startTimeMoment = moment(startTime)
  const endTimeMoment = moment(endTime)

  // eslint-disable-next-line prefer-const
  let availablePeriods = [
    {
      start: moment(startDate)
        .set('hour', startTimeMoment.get('hour'))
        .set('minute', startTimeMoment.get('minute'))
        .set('second', 0)
        .set('millisecond', 0)
        .toISOString(),
      end: moment(startDate)
        .set('hour', endTimeMoment.get('hour'))
        .set('minute', endTimeMoment.get('minute'))
        .set('second', 0)
        .set('millisecond', 0)
        .toISOString(),
    },
  ]
  if (moment(endDate).isAfter(moment(startDate), 'day')) {
    do {
      const last = availablePeriods[availablePeriods.length - 1]
      availablePeriods.push({
        start: moment(last.start).add(1, 'days').toISOString(),
        end: moment(last.end).add(1, 'days').toISOString(),
      })
    } while (!moment(availablePeriods[availablePeriods.length - 1].start).isSame(moment(endDate), 'day'))
  }

  // Filter out saturdays and sundays
  return availablePeriods.filter(
    availablePeriod => moment(availablePeriod.start).isoWeekday() < 6
  )
}

export const isUserCalendarConnected = (calendarsConnected, email) => calendarsConnected
  && !!get(calendarsConnected.find(calendarConnected => calendarConnected.email === email),
    'calendarConnected')
